import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { parseHttpErrorBody } from '../../shared/forms/parse-http-error-body';
import 'rxjs/Rx';
import {Observable} from 'rxjs/Observable';

import {GlobalVariable} from '../../global';
import {Permission} from './permission.model';
import {
  RequestParameters
} from '../../shared/models/request-parameters/parameter.model';

@Injectable()

export class PermissionService {

  constructor(private http: HttpClient) {
  }

  getPermissions (parameters: RequestParameters = new RequestParameters()) {

    parameters.limit = 10000;
    parameters.offset = 0;

    return this.http.get(GlobalVariable.BASE_API_URL + '/permissions', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: HttpResponse<any>) => {
          return response;
        }
      ).catch(
      (error: HttpErrorResponse) => {
        return Observable.throw({
          code: error.status,
          content: JSON.parse(error.error).message,
          body: parseHttpErrorBody(error)
        });
      }
    );

  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/parameters/roles/permission.service.ts